import styled from "styled-components";

/**
 * Wrapper do conteúdo principal (Desktop)
 */
export const HeroContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing(4)};
  z-index: 2;
`;

/**
 * Wrapper do cabeçalho da seção (Desktop)
 */
export const HeroHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding-top: ${({ theme }) => theme.spacing(10)};
  margin: 0 auto;
  max-width: ${({ theme }) => theme.breakpoints.md};

  & > span {
    text-align: center;
  }
`;
